<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-12 17:10:00
 -->
<!--  -->
<template>
    <basicContainer>
        <div class="announcementManage">

            <!-- 主数据表 -->
            <easyCruds ref="mainTable" :tableInfo="mainTable"
                      @mainTableReload="mainTableReload"
                      @beforeEditFunctionName="beforeEditFunctionName"
                      @deleteRows="deleteRows"
                      @xxxChange="xxxChange"
                      @xzyChange="xzyChange"
                      @goReturn="goReturn"
                        @editRow="editRow">
                <template  slot="xhForm" slot-scope="{easyFormInfo,disabled,data,label,prop}">
                    <el-input :disabled="disabled" v-model="data[prop]" placeholder="请输入内容" @blur="xhChange(data[prop],data)">

                    </el-input>
                </template>
            </easyCruds>

        </div>
    </basicContainer>
</template>

<script>
    export default {
        data() {
            return {
                classXydm:'',
                classZydm: '',
                obj:{},
                mainTable: {
                    buttonSetting: {
                        allowAdd: true,
                        addButtonArray:[{
                            clickEvent: 'editRow',
                            type:'primary',
                            buttonName:'新增',
                            validate:true
                        }],
                        beforeEditFunctionName: 'beforeEditFunctionName',
                        allowEdit: true,
                        editButtonArray:[{
                            clickEvent:'editRow',
                            type:'primary',
                            buttonName:'保存编辑',
                            validate: true
                        }],
                        allowDelete: true,
                        deleteFunctionName: 'deleteRows',
                        allowView: false,
                        allowMoreDelete: false,
                        left: [
                            {
                                title: '返回',
                                type: 'primary',
                                clickEvent: 'goReturn',
                                icon: 'fa fa-arrow-circle-left'
                            }
                        ],
                        right: []
                    },
                    header: {
                        title: '班级明细'
                    },
                    table: {
                        loading: false,
                        height: 550,
                        stripe: true,
                        conditionLabelWidth: 'auto',
                        selection: true,
                        index: true,
                        columns: [ {
                            prop: 'xh',
                            label: '学号',
                            formslot: true,
                            isSearchCondition: true,
                            type: 'input',
                            required: true,
                            span: 12,

                            dicData: []
                        },{
                            prop: 'id',
                            label: 'id',
                            isSearchCondition: false,
                            type: 'input',
                            required: true,
                            span: 12,
                            view: [false, false,false],
                            showInTable: false,
                            dicData: [],

                        }, {
                            prop: 'xm',
                            label: '姓名',
                            isSearchCondition: true,
                            type: 'input',
                            required: false,
                            span: 12,
                            dicData: [],
                            disabled: [true, true, true]
                        }, {
                            prop: 'xbmc',
                            label: '性别',
                            isSearchCondition: false,
                            type: 'input',
                            required: false,
                            span: 12,
                            dicData: [],
                            view: [false, false, false]
                        }, {
                            prop: 'xn',
                            label: '参评学年',
                            isSearchCondition: true,
                            type: 'select',
                            span: 12,
                            required: true,
                            showInTable: false,
                            dicData: [{label: '2019-2020', value: '2019-2020'}]
                        },{
                            prop: 'xymc',
                            label: '参评学院',
                            isSearchCondition: false,
                            required: true,
                            type: 'select',
                            span: 12,
                            view: [false, false, false],
                            dicData: [],
                        },{
                            prop: 'xydm',
                            label: '参评学院',
                            isSearchCondition: true,
                            required: true,
                            type: 'select',
                            showInTable: false,
                            span: 12,
                            searchChangeFunction: 'xxxChange',//学院触发事件
                            onChange: (item, value, cpmpution) => {
                                if (!value){
                                    this.$set(cpmpution.data, 'zydm', '')
                                    this.$set(cpmpution.data, 'bjdm', '')
                                    return
                                }
                                if(this.classXydm!=cpmpution.data.xydm){
                                    this.$set(cpmpution.data, 'zydm', '')
                                }
                                this.xxxChange({ value }, null, (dicData) => {
                                    cpmpution.form.formItems.forEach(ele => {
                                        if (ele.prop === 'zydm') {
                                            this.$set(ele, 'dicData', dicData)
                                        }
                                    })
                                })
                            },
                            dicData: [],
                        }, {
                            prop: 'zymc',
                            label: '参评专业',
                            isSearchCondition: false,
                            type: 'select',
                            required: true,
                            span: 12,
                            view: [false, false, false],
                            dicData: []
                        }, {
                            prop: 'zydm',
                            label: '参评专业',
                            isSearchCondition: true,
                            type: 'select',
                            required: true,
                            showInTable:false,
                            span: 12,
                            searchChangeFunction: 'xzyChange',//专业触发事件
                            onChange: (item, value, cpmpution) => {
                                if (!value){
                                    this.$set(cpmpution.data, 'bjdm', '')
                                    return
                                }
                                if(this.classZydm!=cpmpution.data.zydm){
                                    this.$set(cpmpution.data, 'bjdm', '')
                                }
                              //  cpmpution.data.bjdm=''
                                this.xzyChange({ value }, null, (dicData) => {
                                    cpmpution.form.formItems.forEach(ele => {
                                        if (ele.prop === 'bjdm') {
                                            this.$set(ele, 'dicData', dicData)
                                        }
                                    })
                                })
                            },
                            dicData: []
                        }, {
                            prop: 'bjmc',
                            label: '参评班级',
                            isSearchCondition: false,
                            type: 'select',
                            required: true,
                            span: 12,
                            view: [false, false, false],
                            dicData: []
                        }, {
                            prop: 'bjdm',
                            label: '参评班级',
                            isSearchCondition: true,
                            showInTable:false,
                            type: 'select',
                            required: true,
                            span: 12,
                            dicData: []
                        },{
                            prop: 'xxy',
                            label: '现学院',
                            isSearchCondition: false,
                            type: 'select',
                            required: false,
                            span: 12,
                            dicData: [],
                            disabled: [true, true, true]
                        }, {
                            prop: 'xzy',
                            label: '现专业',
                            isSearchCondition: false,
                            type: 'select',
                            required: false,
                            span: 12,
                            dicData: [],
                            disabled: [true, true, true]
                        }, {
                            prop: 'xnj',
                            label: '现年级',
                            isSearchCondition: false,
                            type: 'select',
                            required: false,
                            span: 12,
                            dicData: [],
                            showinTable: false,
                            disabled: [true, true, true]
                        }, {
                            prop: 'xbj',
                            label: '现班级',
                            isSearchCondition: false,
                            type: 'select',
                            required: false,
                            span: 12,
                            dicData: [],
                            disabled: [true, true, true]
                        }],
                        operation: {
                            width: '220',
                        },
                        tableData: [],
                        paging: {
                            currentPage: 1,
                            pageSizes: [10, 15, 20, 25],
                            pageSize: 10,
                            total: 0
                        },
                        reload: 'mainTableReload',
                        reloadConditions: {},
                        addDefultValue: {}
                    }

                },
                // 缓存年级
                njArray:[],
                flag: false
            }
        },

        mounted() {
            /* 列表渲染*/
           // this.mainTableReload({ pageNum: 1, pageSize: 10 })
           // let that = this

            setTimeout(()=>{
                this.getXY()
                //年级
                this.getNJ()

                this.getXN()

                this.getZY()
                this.getBJ()
            }, 1000)
        },
        methods: {
            mainTableReload: function(params) {
                this.mainTable.table.loading = true
                this.$http.get('/qpxx/query',{
                    params
                }).then(
                    response => {
                        this.mainTable.table.loading = false
                        // 成功之后的数据
                        this.mainTable.table.tableData = response.data.records
                        this.mainTable.table.paging.total = response.data.total || response.data.records.length
                        return true

                    }
                ).catch(
                    error => {
                        this.$message.error(error.msg)
                    }
                )
            },
            getXY: function() {
                this.$http.post('/college/getCollegeCode').then(response => {
                    let result = []
                    response.data.forEach(element => {
                        result.push({
                            label: element.bmmc,
                            value: element.bmdm
                        })
                    })
                    let that = this
                   setTimeout(function () {
                       that.$refs.mainTable.setColumnSeting('xymc', 'dicData', result)
                       that.$refs.mainTable.setColumnSeting('xydm', 'dicData', result)

                       if(result.length!==0){
                           that.mainTable.table.reloadConditions.xydm =  that.$route.query.cpxy
                           that.$refs.mainTable.reload()
                       }
                   }, 100)

                }).catch(error => {
                    this.$message.error(error.msg)
                })
            },

            getZY: function() {
                this.$http.post('/specialty/getSpecialtyCode').then(response => {
                    let result = []
                    response.data.forEach(element => {
                        result.push({
                            label: element.zymc,
                            value: element.zydm
                        })
                    })
                    this.$refs.mainTable.setColumnSeting('zymc', 'dicData', result)
                    this.$refs.mainTable.setColumnSeting('zydm', 'dicData', result)

                    if(result.length!==0){
                        this.mainTable.table.reloadConditions.zydm =  this.$route.query.zydm
                        this.$refs.mainTable.reload()
                    }

                }).catch(error => {
                    this.$message.error(error.msg)
                })
            },
            getNJ: function() {
                this.$http.get('/common-portal/getCommonNjxx').then(response => {
                    let result = []
                    response.data.forEach(element => {
                        result.push({
                            label: element.itemValue,
                            value: element.itemCode
                        })
                    })
                    this.$refs.mainTable.setColumnSeting('nj', 'dicData', result)


                }).catch(error => {
                    this.$message.error(error.msg)
                })
            },
            deleteRows: function(deleteList) {
                let id = (deleteList.map(item => item.id))[0]
                let params = {id: id}
                this.$http.post('/qpxx/delete',null,  {params
                }).then(response => {
                    this.$message.success('删除成功')
                    this.mainTableReload(this.$refs.mainTable.getReloadConditions())
                }).catch(error => {
                    this.$message.error(error.msg)
                })
            },
            xhChange: function(xh, data) {
                if(!xh){
                    // this.$message.warning('学号不存在')
                    return
                }
                 this.$http.get('/stuBase/get', {
                     params: {
                         xh,
                         type: '12'
                     }}).then(response => {
                         try{
                             data.xm = response.data.xsJbxx.xm
                             data.xxy = response.data.xsXjxx.yxmc
                             data.xzy = response.data.xsXjxx.zymc
                             data.xnj = response.data.xsXjxx.xznj
                             data.xbj = response.data.xsXjxx.bjmc
                             this.flag = true
                         }catch (e) {
                             console.log(e)
                             data.xm = ''
                             data.xxy = ''
                             data.xzy = ''
                             data.xnj = ''
                             data.xbj = ''
                             this.$message.error("未查询到信息或信息不完整")
                             this.flag = false
                         }
                     this.$forceUpdate()
                 }).catch(error => {
                     this.$message.error(error.msg)
                 })


            },
            xxxChange: function(val, data, callback) {
                if (!val.value && !callback) {
                    (data.yzy = data.ybj = data.zydm = data.bjdm = '')
                    return
                } else if (!val.value && callback) {
                    typeof callback === 'function' && callback([])
                }
                let newVaule = val.value
                this.$http.get('/specialty/getZyxxByXy', { params: {
                        bmid: val.value
                    }}).then(response => {
                    let result = []
                    response.data.forEach(element => {
                        result.push({
                            label: element.zymc,
                            value: element.zydm
                        })
                    })
                    if (callback) {
                        typeof callback === 'function' && callback(result)
                    } else {
                        //this.$refs.mainTable.setColumnSeting('yzy', 'dicData', result)
                        this.$refs.mainTable.setColumnSeting('zymc', 'dicData', result)
                        this.$refs.mainTable.setColumnSeting('zydm', 'dicData', result)
                        let that = this
                        if(Number(newVaule)==Number(that.$route.query.cpxy)){
                            that.mainTable.table.reloadConditions.zymc = that.$route.query.zymc
                            that.mainTable.table.reloadConditions.zydm = that.$route.query.zydm
                        }else {
                            that.mainTable.table.reloadConditions.zymc = ''
                            that.mainTable.table.reloadConditions.zydm = ''
                            that.mainTable.table.reloadConditions.bjmc = ''
                            that.mainTable.table.reloadConditions.bjdm = ''
                        }
                    }
                }).catch(error => {
                    this.$message.error(error.msg)
                })
            },
            xzyChange: function(val, data, callback){

                if (!val.value && !callback) {
                    (data.yzy = data.ybj = data.zydm = data.bjdm = '')
                    return
                } else if (!val.value && callback) {
                    typeof callback === 'function' && callback([])
                }
                let newVaule = val.value
                this.$http.get('/BjInfo/getBjxxByZy', {params:{
                        zydm:val.value
                    }}).then(response => {
                    let result = []
                    response.data.forEach(element => {
                        result.push({
                            label: element.bjmc,
                            value: element.bjdm
                        })
                    })

                    if (callback) {
                        typeof callback === 'function' && callback(result)
                    } else {
                        // this.$refs.mainTable.setColumnSeting('ybj', 'dicData', result)
                        this.$refs.mainTable.setColumnSeting('bjmc', 'dicData', result)
                        this.$refs.mainTable.setColumnSeting('bjdm', 'dicData', result)
                        let that = this
                        if(Number(newVaule)==Number(that.$route.query.zydm)){
                            that.mainTable.table.reloadConditions.bjmc = that.$route.query.bjmc
                            that.mainTable.table.reloadConditions.bjdm = that.$route.query.bjdm
                        }else {
                            that.mainTable.table.reloadConditions.bjmc = ''
                            that.mainTable.table.reloadConditions.bjdm = ''
                        }

                    }


                }).catch(error => {
                    this.$message.error(error.msg)
                })
            },
            sortBy: function(attr,rev){
                //第二个参数没有传递 默认升序排列
                if(rev ==  undefined){
                    rev = 1;
                }else{
                    rev = (rev) ? 1 : -1;
                }

                return function(a,b){
                    a = a[attr];
                    b = b[attr];
                    if(a < b){
                        return rev * -1;
                    }
                    if(a > b){
                        return rev * 1;
                    }
                    return 0;
                }
            },
            getXN: function(){
                this.$http.get('/Xn/queryMap').then(response => {
                    let result = []
                    response.data.forEach(element => {
                        result.push({
                            label: element.xnd,
                            value: element.id
                        })
                    })
                    result=result.sort(this.sortBy('label',false));
                    this.$refs.mainTable.setColumnSeting('xn', 'dicData', result)
                    let that = this
                    if(result.length!==0){
                        that.mainTable.table.reloadConditions.xn =that.$route.query.xn
                        //  this.$refs.mainTable.reload()
                    }
                }).catch(error => {
                    this.$message.error(error.msg)
                })

            },
            goReturn: function () {
                this.$router.push({name:'班级切片管理', query: {xn: this.$route.query.xn,cpxy: this.$route.query.cpxy, bjqpPageNo: this.$route.query.bjqpPageNo, bjqpTotal:  this.$route.query.bjqpTotal,pageNo: this.$route.query.pageNo, total: this.$route.query.total}})
            },

            beforeEditFunctionName: function(row, type, callback) {
                this.classXydm = row.xydm
                this.classZydm = row.zydm
                callback(row)
            },
            editRow: function (row, done, errorDone,note,setting,oldData) {
                // if(this.flag){
                    this.$http.post('/qpxx/addOrUpdate', row).then(response => {
                        this.$message.success('更新成功') && done()
                        this.mainTableReload(this.$refs.mainTable.getReloadConditions())
                    }).catch(error => {
                        this.$message.error(error.msg)
                    })
                // }else {
                //     this.$message.error('该生不存在') && errorDone()
                // }

            },
            getBJ: function () {
                let result = []
                result.push({
                    label: this.$route.query.bjmc,
                    value:  this.$route.query.bjdm
                })
                let that = this
                setTimeout(function () {
                    that.$refs.mainTable.setColumnSeting('bjmc', 'dicData', result)
                    that.$refs.mainTable.setColumnSeting('bjdm', 'dicData', result)

                    if(result.length!==0){
                        that.mainTable.table.reloadConditions.bjdm =  that.$route.query.bjdm
                        that.mainTable.table.reloadConditions.bjmc =  that.$route.query.bjmc
                        that.$refs.mainTable.reload()
                    }
                }, 100)
            }
        }
    }
</script>

<style lang='scss'>

    .quill-editor {
        height: 300px;
    }
    .easyCrud .el-form-item {
        height: 44px !important;
    }
</style>
